var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataReportWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49748 14.583V12.083M9.66415 14.583V7.08301M13.8308 14.583V11.2497",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9975 4.58301C17.9975 5.96372 16.8782 7.08301 15.4975 7.08301C14.1167 7.08301 12.9975 5.96372 12.9975 4.58301C12.9975 3.2023 14.1167 2.08301 15.4975 2.08301C16.8782 2.08301 17.9975 3.2023 17.9975 4.58301Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9937 9.16634C17.9937 9.16634 17.9975 9.44926 17.9975 9.99967C17.9975 13.7317 17.9975 15.5976 16.8381 16.757C15.6787 17.9163 13.8127 17.9163 10.0808 17.9163C6.34886 17.9163 4.48288 17.9163 3.32351 16.757C2.16414 15.5976 2.16414 13.7317 2.16414 9.99967C2.16414 6.26775 2.16414 4.40177 3.32351 3.2424C4.48288 2.08303 6.34886 2.08303 10.0808 2.08303L10.9141 2.08301",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataReportWhite);
export default __webpack_public_path__ + "static/media/data-report-white.d389216ec875205f9c56514b15fd02bf.svg";
export { ForwardRef as ReactComponent };